import React from 'react';
import { StyledBadge, StyledBadgeContainer, StyledLabel } from './Badge.styles';

export interface BadgeProps {
  label: string;
  dataQaId?: string;
  value?: number;
  maxValue?: number;
  hideMaxValue?: boolean;
}

const Badge: React.FC<BadgeProps> = ({ label, dataQaId, value = 0, maxValue = 0, hideMaxValue }: BadgeProps) => {
  const done = value >= maxValue;

  const maxValueStr = hideMaxValue ? '' : `/${maxValue}`;

  return (
    <StyledBadgeContainer data-qa-id={`${dataQaId}-container`}>
      <StyledLabel data-qa-id={`${dataQaId}-label`}>{label}</StyledLabel>
      <StyledBadge data-qa-id={`${dataQaId}-badge`} done={done}>{`${value}${maxValueStr}`}</StyledBadge>
    </StyledBadgeContainer>
  );
};

export default Badge;
